import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

import { ResidentialCalculator } from '../Calculators'

import * as info from './info'

import UnitToggle from '../Widgets/UnitToggle'
import CalculationGroup from '../Widgets/CalculationGroup'

export default class GrossDevelopmentValueForm extends Component {
  static propTypes = {
    calculator: PropTypes.instanceOf(ResidentialCalculator).isRequired,
    data: PropTypes.shape({
      unitCount: PropTypes.number,
      unitSize: PropTypes.number,
      totalArea: PropTypes.number,
      salesValue: PropTypes.number,
    }).isRequired,
    readOnly: PropTypes.bool,
    updateField: PropTypes.func,
    updateUnit: PropTypes.func,
  }

  handleFieldChangedFactory = (field) => (value) => this.props.updateField(field, value)

  render() {
    const { calculator, data, readOnly, updateUnit } = this.props

    return (
      <Fragment>
        <h2>Gross Development Value</h2>

        {! readOnly && <UnitToggle onChange={updateUnit} value={data.unit} />}

        <CalculationGroup
          readOnly={readOnly}
          field='netLandArea'
          info={info.netLandArea}
          label='Developable land'
          value={data.netLandArea}
          unit={data.unit}
          onChange={readOnly ? null : this.handleFieldChangedFactory('netLandArea')}
          average={calculator.getDensity(true)}
          averageType='number'
          averageLabel={`Density (dwellings per ${calculator.getUnitAreaLabel(true)})`}
          total={calculator.getTotalArea(false)}
          totalType='area'
          totalLabel='Total land area'
          input={{ suffix: calculator.getUnitAreaLabel(true) }}
        />

        <CalculationGroup
          readOnly={readOnly}
          field='unitCountPrivate'
          info={info.unitCountPrivate}
          label='No. of private dwellings'
          value={data.unitCountPrivate}
          unit={data.unit}
          onChange={readOnly ? null : this.handleFieldChangedFactory('unitCountPrivate')}
          input={{ autoFocus: true, small: true, allowZero: true  }}
        />
        <CalculationGroup
          readOnly={readOnly}
          field='unitSizePrivate'
          info={info.unitSizePrivate}
          label='Private unit size'
          value={data.unitSizePrivate}
          unit={data.unit}
          onChange={readOnly ? null : this.handleFieldChangedFactory('unitSizePrivate')}
          total={calculator.getTotalPrivateUnitSize()}
          totalType='area'
          totalLabel='Total private unit size'
          input={{ suffix: calculator.getUnitAreaLabel(), allowZero: true  }}
        />
        <CalculationGroup
          readOnly={readOnly}
          field='salesValuePrivate'
          info={info.salesValuePrivate}
          label='Private sales value'
          value={data.salesValuePrivate}
          unit={data.unit}
          onChange={readOnly ? null : this.handleFieldChangedFactory('salesValuePrivate')}
          average={calculator.getPrivateAverage(calculator.getPrivateSalesValueTotal())}
          total={calculator.getPrivateSalesValueTotal()}
          input={{
            prefix: '£',
            suffix: calculator.getPerUnitAreaLabel(),
            allowZero: true
          }}
        />

        <CalculationGroup
          readOnly={readOnly}
          field='unitCountAffordable'
          info={info.unitCountAffordable}
          label='No. of affordable dwellings'
          value={data.unitCountAffordable}
          unit={data.unit}
          onChange={readOnly ? null : this.handleFieldChangedFactory('unitCountAffordable')}
          input={{ autoFocus: true, small: true, allowZero: true }}
        />
        <CalculationGroup
          readOnly={readOnly}
          field='unitSizeAffordable'
          info={info.unitSizeAffordable}
          label='Affordable unit size'
          value={data.unitSizeAffordable}
          unit={data.unit}
          onChange={readOnly ? null : this.handleFieldChangedFactory('unitSizeAffordable')}
          total={calculator.getTotalAffordableUnitSize()}
          totalType='area'
          totalLabel='Total affordable unit size'
          input={{ suffix: calculator.getUnitAreaLabel(), allowZero: true }}
        />
        <CalculationGroup
          readOnly={readOnly}
          field='salesValueAffordable'
          info={info.salesValueAffordable}
          label='Affordable sales value'
          value={data.salesValueAffordable}
          unit={data.unit}
          onChange={readOnly ? null : this.handleFieldChangedFactory('salesValueAffordable')}
          average={calculator.getAffordableAverage(calculator.getAffordableSalesValueTotal())}
          total={calculator.getAffordableSalesValueTotal()}
          input={{
            prefix: '£',
            suffix: calculator.getPerUnitAreaLabel(),
            allowZero: true
          }}
        />
      </Fragment>
    )
  }
}
